"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TopAreaBannerContent = require("./TopAreaBannerContent");
Object.keys(_TopAreaBannerContent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TopAreaBannerContent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TopAreaBannerContent[key];
    }
  });
});
var _TopAreaBannerDialog = require("./TopAreaBannerDialog");
Object.keys(_TopAreaBannerDialog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TopAreaBannerDialog[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TopAreaBannerDialog[key];
    }
  });
});
var _TopAreaBannerSkeleton = require("./TopAreaBannerSkeleton");
Object.keys(_TopAreaBannerSkeleton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TopAreaBannerSkeleton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TopAreaBannerSkeleton[key];
    }
  });
});
var _BannersCarousel = require("./BannersCarousel");
Object.keys(_BannersCarousel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BannersCarousel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BannersCarousel[key];
    }
  });
});
